import { Menubar } from "primereact/menubar";
import logo from "../assets/images/CAC-logo.png";
import { Button } from "primereact/button";
import { useNavigate, Link } from "react-router-dom";
import { MySocialNetworks } from "./Common/MySocialNetworks";

const CustomMenu = () => {
  let navigate = useNavigate();

  // Helper function for creating internal menu items
  const createInternalLinkItem = (label, path) => ({
    template: (
      <span
        className="inline-flex gap-1 px-2 py-2"
        style={{
          display: "flex", // Ensure flex container
          flexDirection: "column", // Stack text vertically
          alignItems: "flex-start", // Align text to the start (left)
          width: "100%", // Ensure full width for alignment
        }}
      >
        <Link
          to={path}
          style={{
            textDecoration: "none",
            color: "black",
            textAlign: "left", // Explicitly set text alignment
            display: "block", // Ensure Link behaves like a block element
          }}
        >
          {label}
        </Link>
      </span>
    ),
    command: () => navigate(path),
  });

  const createExternalLinkItem = (label, url) => ({
    template: (
      <span
        className="inline-flex gap-1 px-2 py-2"
        style={{
          display: "flex",
          flexDirection: "row", // changed from column
          alignItems: "center", // vertically center if needed
          justifyContent: "flex-start", // horizontally align left
          width: "100%",
        }}
      >
        <a
          href={url}
          className="menu-link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "black",
            textAlign: "left", // force text to align left
            width: "100%",
          }}
        >
          {label}
        </a>
      </span>
    ),
    label: (
      <span
        className="inline-flex gap-1 px-2 py-2"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "100%",
        }}
      >
        <a
          href={url}
          className="menu-link"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "black",
            textAlign: "left",
            width: "100%",
          }}
        >
          {label}
        </a>
      </span>
    ),
    url: { url },
  });

  const items = [
    {
      label: "The Diplomatic and Consular Networks Database and Rankings",
      items: [
        createExternalLinkItem("GIS platform", "https://arcg.is/1TDPiy1"),
        createInternalLinkItem("Ranking (of country)", "/ranking-of-country"),
        createInternalLinkItem("Ranking (in country)", "/ranking-in-country"),
        createInternalLinkItem("Ranking (in city)", "/ranking-in-city"),
        createInternalLinkItem(
          "Daily database review",
          "/daily-database-review",
        ),
        createExternalLinkItem(
          "Methodology",
          "https://doi.org/10.5281/zenodo.14034984",
        ),
        createInternalLinkItem("Update", "/update"),
      ],
    },
    {
      label: "Publications",
      items: [
        createExternalLinkItem(
          "2026 Ranking Report",
          "https://doi.org/10.5281/zenodo.18109975",
        ),
        createInternalLinkItem(
          "The Consular Bibliography",
          "/the-consular-bibliography",
        ),
        createInternalLinkItem(
          "The Consular Daily Press Review",
          "/the-consular-daily-press-review",
        ),
        createInternalLinkItem("The Consular Journal (TBA)", ""),
        createExternalLinkItem(
          "The Consular Magazine",
          "https://magazine.consularaffairs.org",
        ),
        createInternalLinkItem(
          "The Consular Newsletter",
          "/the-consular-newsletter",
        ),
        createExternalLinkItem(
          "The Consular Repository",
          "https://zenodo.org/communities/theconsularrepository",
        ),
        createInternalLinkItem("Authors", "/authors"),
        createInternalLinkItem("Index", "/index"),
        createInternalLinkItem(
          "Submission guidelines",
          "/submission-guidelines",
        ),
      ],
    },
    {
      label: "Honorary consuls",
      items: [
        createInternalLinkItem(
          "Who are honorary consuls?",
          "/who-are-honorary-consuls",
        ),
        createInternalLinkItem(
          "Honorary bibliography",
          "/honorary-bibliography",
        ),
        createInternalLinkItem(
          "Honorary corps directory",
          "/honorary-corps-directory",
        ),
        createInternalLinkItem("Honorary jobs", "/honorary-jobs"),
        createInternalLinkItem("Honorary news", "/honorary-news"),
        createInternalLinkItem("Honorary solutions", "/honorary-solutions"),
        createInternalLinkItem("Henry Graham Greene", "/henry-graham-greene"),
      ],
    },
    {
      label: "Resources",
      items: [
        createInternalLinkItem(
          "What are consular affairs?",
          "/what-are-consular-affairs",
        ),
        createInternalLinkItem(
          "What are diplomatic networks?",
          "/what-are-diplomatic-networks",
        ),
        createInternalLinkItem(
          "Etymology and history",
          "/etymology-and-history",
        ),
        createInternalLinkItem(
          "1961 and 1963 Vienna conventions",
          "/1961-and-1963-vienna-conventions",
        ),
        createInternalLinkItem(
          "Consular jobs and internships",
          "/consular-jobs-and-internships",
        ),
        createInternalLinkItem("Did you know?", "/did-you-know"),
        createInternalLinkItem("Diplomatic directory", "/diplomatic-directory"),
        createInternalLinkItem(
          "Global Consular Forum",
          "/global-consular-forum",
        ),
        createInternalLinkItem("Glossary", "/glossary"),
        createInternalLinkItem("Interesting links", "/interesting-links"),
        createInternalLinkItem(
          "International organizations",
          "/international-organizations",
        ),
        createInternalLinkItem(
          "Migration laws, regulations, and policies",
          "/migration-laws-regulations-and-policies",
        ),
        createInternalLinkItem(
          "Passports, visas, and migration fraud",
          "/passports-visas-and-migration-fraud",
        ),
      ],
    },
    {
      label: "The Research Institute",
      items: [
        createInternalLinkItem("About", "/about"),
        createInternalLinkItem("Research fellows", "/research-fellows"),
        createInternalLinkItem("Contributors", "/contributors"),
        createInternalLinkItem("Correspondents", "/correspondents"),
        createInternalLinkItem("Partners", "/partners"),
        createInternalLinkItem("Notice", "/notice"),
        createInternalLinkItem(
          "Support consular research",
          "/support-consular-research",
        ),
        createInternalLinkItem("Careers (TBA)", ""),
        createInternalLinkItem("Contact", "/contact"),
      ],
    },
  ];

  const start = (
    <Link to="/">
      <img src={logo} alt="Image" className="cac-logo-size" />
    </Link>
  );

  const navigateToDonate = () => {
    navigate("/donate");
  };

  const end = (
    <Button
      label="Donate"
      className="button-donate"
      onClick={navigateToDonate}
    />
  );

  return (
    <header className="menu-bar">
      <div className="reduce-width">
        <Menubar model={items} start={start} />
        <div className="flex justify-content-end flex-wrap">
          <div
            className="flex align-items-center justify-content-center mr-2"
            style={{
              textDecoration: "none",
              color: "black",
              textAlign: "center",
            }}
          >
            Get daily news
          </div>
          <div className="flex align-items-center justify-content-center">
            {MySocialNetworks()}
          </div>
          <div className="flex align-items-center justify-content-center privacy-and-terms">
            <span
              style={{ textAlign: "center", width: "100%", color: "black" }}
            >
              or{" "}
              <Link
                to="/the-consular-newsletter"
                style={{
                  textDecoration: "underline",
                  color: "black",
                }}
              >
                subscribe
              </Link>{" "}
              to the weekly newsletter
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CustomMenu;
